export default __webpack_public_path__ + "static/media/moon.13c8c6ea.svg";